import React, {useEffect, useState} from "react"
import Styles from "./wrapper.less"
import {connect} from "react-redux"

function Wrapper(props) {
    const [title, setTitle] = useState("")
    useEffect(() => {
        setTitle(`${props.title}：${props.fileInfo.name}`)
    }, [props.fileInfo, props.title])
    return (
        <div className={Styles.navInfo}>
            <div className={Styles.navTitle}>{title}</div>
        </div>
    )
}

export default connect((state) => {
    return {
        model: state.model,
        loading: state.loading,
        serverUrl: state.serverUrl,
    }
})(Wrapper)
